
const formatSeconds = (seconds) => {
  if (parseFloat(seconds) === 0) return "0s";

  const units = [
    { label: "d", value: 86400 },
    { label: "h", value: 3600 },
    { label: "m", value: 60 },
    { label: "s", value: 1 },
  ];

  let remaining = seconds;
  const parts = [];

  for (let unit of units) {
    if (remaining >= unit.value) {
      const count = Math.floor(remaining / unit.value);
      remaining %= unit.value;
      parts.push(`${count}${unit.label}`);
    }
  }

  return parts.join(" ");
};
export const TimeDisplay = ({seconds}) => {
    return <span>{formatSeconds(seconds)}</span>;
}